import React from 'react';
import { ChevronLeft, ChevronRight, Check, PlayCircle, FileText } from 'lucide-react';
import { useLang, tx } from '../../i18n/LanguageContext';

export const LessonActionBar = ({ prev, next, onGo, done, onToggleDone, locked }) => {
  const { lang, isRTL } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const Next = isRTL ? ChevronLeft : ChevronRight;
  const Prev = isRTL ? ChevronRight : ChevronLeft;
  const btn = 'h-10 px-4 rounded-xl text-sm font-semibold inline-flex items-center justify-center gap-1.5 whitespace-nowrap disabled:opacity-40 disabled:pointer-events-none transition-colors';
  return (
    <div data-testid="lesson-actions-card" className="grid grid-cols-3 sm:flex sm:flex-wrap lg:flex-nowrap lg:shrink-0 lg:pt-5 items-center gap-2 w-full sm:w-auto">
      {!locked && (
        <button type="button" data-testid="learn-complete-btn" onClick={onToggleDone} aria-pressed={done} title={done ? L('تم إكمال الدرس', 'Completed') : L('تحديد كمكتمل', 'Mark complete')}
          className={`${btn} order-3 px-2 sm:px-3 border ${done ? 'bg-emerald-50 border-emerald-200 text-emerald-700 hover:bg-emerald-100' : 'bg-white border-slate-200 text-slate-600 hover:bg-slate-50'}`}>
          <span className={`w-4 h-4 rounded border flex items-center justify-center shrink-0 ${done ? 'bg-emerald-500 border-emerald-500 text-white' : 'border-slate-300 bg-white'}`}>{done && <Check className="w-3 h-3" />}</span>
          <span className="truncate">{done ? L('مكتمل', 'Completed') : <><span className="sm:hidden">{L('مكتمل؟', 'Done?')}</span><span className="hidden sm:inline">{L('تحديد كمكتمل', 'Mark complete')}</span></>}</span>
        </button>
      )}
      <button type="button" data-testid="learn-prev-btn" disabled={!prev} onClick={() => onGo(prev)} className={`${btn} order-2 px-2 sm:px-4 border border-slate-200 bg-white text-slate-700 hover:bg-slate-50`}>
        <Prev className="w-4 h-4 shrink-0" /><span className="sm:hidden">{L('السابق', 'Prev')}</span><span className="hidden sm:inline">{L('الدرس السابق', 'Previous')}</span>
      </button>
      <button type="button" data-testid="learn-next-btn" disabled={!next} onClick={() => onGo(next)} className={`${btn} order-1 px-2 sm:px-4 bg-blue-600 hover:bg-blue-700 text-white shadow-md shadow-blue-600/20 ${locked ? 'col-span-2' : ''}`}>
        <span className="sm:hidden">{L('التالي', 'Next')}</span><span className="hidden sm:inline">{L('الدرس التالي', 'Next lesson')}</span><Next className="w-4 h-4 shrink-0" />
      </button>
    </div>
  );
};

const parse = (s) => { const [t, time] = String(s).split('|').map(x => x.trim()); return { t, time: time || '' }; };

export const LessonOutlineCard = ({ outline }) => {
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  if (!outline?.length) return null;
  return (
    <div data-testid="lesson-outline-card" className="mt-6">
      <h4 className="text-sm font-bold text-slate-900 mb-2">{L('محتوى الدرس', 'Lesson content')}</h4>
      <ul className="divide-y divide-slate-100">
        {outline.map((o, i) => {
          const { t, time } = parse(lang === 'ar' ? o.ar : o.en);
          const Icon = i === 0 ? PlayCircle : FileText;
          return (
            <li key={i} data-testid={`lesson-outline-item-${i}`} className="flex items-center gap-2.5 py-2">
              <Icon className="w-4 h-4 text-slate-400 shrink-0" />
              <span className="flex-1 min-w-0 text-sm text-slate-700">{t}</span>
              {time && <span className="text-xs text-slate-400" dir="ltr">{time}</span>}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
